import { Chip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { ReactComponent as CheckBorderlessIcon } from 'assets/checkBorderless.svg';
import { ReactComponent as CrossIcon } from 'assets/cross.svg';
import { HiringActivity } from 'modules/hiring/models/candidatePipeline.model';
import {
  HMDecisionTags,
  MakeDecisionStatus,
  TMakeDecisionStatus,
} from 'modules/hiring/models/hiringDecisionOption';
import React, { FC } from 'react';
import { colors } from 'styles/colors';

const CustomChip = withStyles({
  root: {
    width: 'fit-content',
    position: 'relative',
  },
  deleteIcon: {
    margin: '0 0 0 0.5rem !important',
    cursor: 'default !important',
  },
})(Chip);

interface IDecisionTag {
  decision?: 'advance' | 'reject' | 'offer' | 'offerReject';
}

export const DecisionTag: FC<IDecisionTag> = ({ decision = 'advance' }) => {
  const tag = {
    advance: {
      label: HMDecisionTags.Recommended,
      color: colors.tertiary.green,
      background: 'rgba(139, 219, 36, 0.10)',
      icon: <CheckBorderlessIcon />,
    },
    reject: {
      label: HMDecisionTags.NotRecommended,
      color: colors.tertiary.cadimiumRed,
      background: 'rgba(231, 4, 17, 0.10)',
      icon: <CrossIcon />,
    },
    offer: {
      label: HMDecisionTags.OfferRecommended,
      color: colors.tertiary.green,
      background: 'rgba(139, 219, 36, 0.10)',
      icon: <CheckBorderlessIcon />,
    },
    offerReject: {
      label: HMDecisionTags.OfferNotRecommended,
      color: colors.tertiary.cadimiumRed,
      background: 'rgba(231, 4, 17, 0.10)',
      icon: <CrossIcon />,
    },
  };

  return (
    <CustomChip
      title={tag[decision]?.label}
      label={tag[decision]?.label}
      className='kfic2-bodyTextSmall'
      sx={{
        padding: '4px 8px 4px 12px !important',
        borderRadius: '1rem',
        border: `1px solid ${tag[decision]?.color}`,
        background: tag[decision]?.background,
        cursor: 'default',
        boxShadow: 'none',
        '& .MuiChip-label': {
          padding: '0',
        },
      }}
      onDelete={() => {}}
      deleteIcon={tag[decision]?.icon}
    />
  );
};

export const getDecisionTag = (stage: HiringActivity, decision: TMakeDecisionStatus) => {
  if (stage === HiringActivity.InScreen || stage === HiringActivity.Submit) {
    return (
      <DecisionTag
        decision={decision === MakeDecisionStatus.HiringManagerAdvance ? 'advance' : 'reject'}
      />
    );
  }
  /* istanbul ignore else */
  if (stage === HiringActivity.InInterview || stage === HiringActivity.Interview) {
    return (
      <DecisionTag
        decision={decision === MakeDecisionStatus.HiringManagerOffer ? 'offer' : 'offerReject'}
      />
    );
  }
  return null;
};
